import React from 'react';
import T from 'prop-types';

import { H3 } from '../../../base_ui';
import { RemoveAccountContainer, SecondAccountButton } from './styledComponents';

const SecondAccountRemove = ({ handleOnClickSecondAccountRemove }) => (
  <RemoveAccountContainer>
    <H3>Second Account (Optional)</H3>
    <SecondAccountButton
      isPrimary
      label="Remove"
      onPress={handleOnClickSecondAccountRemove}
    />
  </RemoveAccountContainer>
);

SecondAccountRemove.propTypes = { handleOnClickSecondAccountRemove: T.func.isRequired };

export default SecondAccountRemove;
